// export const base_url = `http://192.168.1.3:8080`;
export const base_url = `https://api.Tomax.exchange`;
